import React, { useCallback, useState } from 'react';
import { Col, Divider } from 'antd';
import { ChevronDownIcon, ChevronUpIcon, StarIcon } from '@/assets/icons/icons';
import { renderInstructionsPreview } from './DynMentionFields';
import type { DynVarOption } from '../hooks/useDynamicVariables';

type Props = {
  defaultCollapsed?: boolean;
  instructionsPreview?: string;
  isEditing?: boolean;
  collectedInfo?: string[];
  onAddInstructions?: () => void;
  readOnly?: boolean;
  dynVarOptions?: DynVarOption[];
};

export const AgentBehaviorSection: React.FC<Props> = ({
  defaultCollapsed = false,
  instructionsPreview = '',
  isEditing,
  collectedInfo = [],
  onAddInstructions,
  readOnly = false,
  dynVarOptions = [],
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((p) => !p);
  }, []);

  const list = collectedInfo.length ? collectedInfo : ['None'];

  return (
    <Col span={24}>
      <div className='agentBehaviorCard'>
        <div className='agentBehaviorHeader'>
          <div className='agentBehaviorHeader__title'>Agent behavior</div>

          <span
            className='agentBehaviorHeader__chevron'
            role='button'
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              toggleCollapsed();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleCollapsed();
              }
            }}
          >
            {collapsed ? (
              <ChevronDownIcon size={16} />
            ) : (
              <ChevronUpIcon size={16} />
            )}
          </span>
        </div>

        {!collapsed && (
          <div className='agentBehaviorBody'>
            <Divider className='agentSuccessOrDivider'></Divider>
            <div className='agentBehaviorLabel'>Agent instructions</div>

            <div className='agentFormIntroPreview'>
              {instructionsPreview?.trim().length > 0
                ? renderInstructionsPreview(instructionsPreview, dynVarOptions)
                : 'Preview here when behavior is added...'}
            </div>

            <div className='agentBehaviorLabel agentBehaviorLabel--spaced'>
              Information to be collected
            </div>

            <ul className='agentBehaviorList'>
              {list.map((x) => (
                <li key={x} className='agentBehaviorList__item'>
                  {x}
                </li>
              ))}
            </ul>

            {!readOnly && (
              <button
                type='button'
                className='agentBehaviorBtn'
                onClick={() => onAddInstructions?.()}
              >
                <StarIcon color='var(--text-primary)' />
                {isEditing
                  ? 'Edit agent instructions'
                  : 'Add agent instructions'}
              </button>
            )}
          </div>
        )}
      </div>
    </Col>
  );
};

export default AgentBehaviorSection;
